import React, { Component } from "react"
import Icon from "components/icon/icon"
import { connect } from "react-redux"
import SmoothCollapse from "react-smooth-collapse"
import moment from "moment"
import copy from "fast-copy"

import HeaderTimerCounter from "./header-timer-counter"

import { toggleTimer, hideTimer, getMissingEntities } from "state/actions"

import { getCurrentUser } from "state/selectors/userSelectors"
import {
	doClickEventListeners,
	doSort,
	momentToApiTimeFormat,
	formatByTimeZone,
	getChangedKeys,
} from "utils"

class HeaderTimer extends Component {
	state = {
		selectedTaskId: null,
		isDropdownOpen: false,
	}

	activeSession = null
	ref = null
	formattedSessionGroups = []

	missingEntitiesByType = {}

	shouldComponentUpdate = (nextProps, nextState) => {
		const changedKeys = getChangedKeys(this.props, nextProps)

		if (this.state !== nextState) {
			return true
		}

		if (changedKeys.length === 2) {
			if (
				changedKeys.includes("tasks") &&
				changedKeys.includes("milestones")
			) {
				return false
			}
		}

		return true
	}

	UNSAFE_componentWillMount = (_) => {
		this.formatSessionGroups(this.props)

		if (this.formattedSessionGroups.length) {
			this.setState({
				selectedTaskId: this.formattedSessionGroups[0].task.id,
			})
		}

		doClickEventListeners(this.handleClick)
	}

	componentDidMount = (_) => {
		if (Object.keys(this.missingEntitiesByType).length) {
			// get missing entities here!
			this.isFetchingMissing = true

			this.props.getMissingEntities(this.missingEntitiesByType, (_) => {})
		}
	}

	componentWillUnmount = (_) => {
		doClickEventListeners(this.handleClick, true)
	}

	handleClick = (e) => {
		if (
			this.ref &&
			!this.ref.contains(e.target) &&
			this.state.isDropdownOpen
		) {
			this.setState({
				isDropdownOpen: false,
			})
		}
	}

	UNSAFE_componentWillUpdate = (nextProps) => {
		// This doesn't render too often.
		let previousActiveTaskId = null
		let nextActiveTaskId = null

		const oldSessionGroups = copy(this.formattedSessionGroups)

		oldSessionGroups &&
			oldSessionGroups.forEach((session) => {
				if (session.isActive) {
					previousActiveTaskId = session.task.id
				}
			})

		this.formatSessionGroups(nextProps)

		const newSessionGroups = copy(this.formattedSessionGroups)

		newSessionGroups.forEach((session) => {
			if (session.isActive) {
				nextActiveTaskId = session.task.id
			}
		})

		if (nextActiveTaskId && previousActiveTaskId !== nextActiveTaskId) {
			this.setState({
				selectedTaskId: nextActiveTaskId,
			})
		}
	}

	changeSelectedTask = (selectedTaskId) => {
		const activeSession = this.formattedSessionGroups.find(
			(sessionGroup) => {
				return sessionGroup.isActive
			},
		)

		if (activeSession) {
			this.props.toggleTimer(activeSession.task)
		}

		this.setState({
			selectedTaskId,
		})

		this.setState({
			isDropdownOpen: false,
		})
	}

	formatSessionGroups = (props) => {
		this.formattedSessionGroups = []

		props.userData.sessions &&
			props.userData.sessions.forEach((sessionId) => {
				const session = props.sessions[sessionId]

				if (!session) {
					return
				}

				const applicableTask = props.tasks
					? props.tasks[session.task_id]
					: null

				if (!applicableTask || !applicableTask.name) {
					this.addMissingEntity("task", session.task_id)
					return
				}

				if (session.stopped_at && applicableTask.deleted_at) {
					return
				}

				const applicableMilestone =
					props.milestones[applicableTask.milestone_id]

				if (!applicableMilestone || !applicableMilestone.name) {
					this.addMissingEntity(
						"milestone",
						applicableTask.milestone_id,
					)
					return
				}

				const stoppedMoment = session.stopped_at
					? formatByTimeZone(session.stopped_at, null, true)
					: null
				const createdMoment = formatByTimeZone(
					session.created_at,
					null,
					true,
				)
				const updatedMoment = formatByTimeZone(
					session.updated_at,
					null,
					true,
				)

				const secondsCount = session.stopped_at
					? stoppedMoment.diff(createdMoment, "seconds")
					: 0

				if (secondsCount < 1 && session.stopped_at) {
					return
				}

				const groupIndexIfExisting =
					this.formattedSessionGroups.findIndex((group) => {
						return group.task.id === applicableTask.id
					})

				const latestInteraction =
					stoppedMoment && stoppedMoment.isAfter(updatedMoment)
						? stoppedMoment
						: updatedMoment

				if (groupIndexIfExisting < 0) {
					this.formattedSessionGroups.push({
						task: applicableTask,
						milestone: applicableMilestone,
						savedSeconds: secondsCount,
						isActive: session.stopped_at ? false : true,
						lastActive: momentToApiTimeFormat(latestInteraction),
						lastUpdated: updatedMoment,
						activeSessionId: !session.stopped_at
							? session.id
							: null,
					})
				} else {
					this.formattedSessionGroups[
						groupIndexIfExisting
					].savedSeconds += secondsCount

					if (!session.stopped_at) {
						this.formattedSessionGroups[
							groupIndexIfExisting
						].isActive = true
						this.formattedSessionGroups[
							groupIndexIfExisting
						].activeSessionId = session.id
					}

					if (
						latestInteraction.isAfter(
							moment(
								this.formattedSessionGroups[
									groupIndexIfExisting
								].lastActive,
							),
						)
					) {
						this.formattedSessionGroups[
							groupIndexIfExisting
						].lastActive = momentToApiTimeFormat(latestInteraction)
					}

					if (
						updatedMoment.isAfter(
							this.formattedSessionGroups[groupIndexIfExisting]
								.lastUpdated,
						)
					) {
						this.formattedSessionGroups[
							groupIndexIfExisting
						].lastUpdated = updatedMoment
					}
				}
			})

		this.formattedSessionGroups = doSort(
			this.formattedSessionGroups,
			"date",
			"lastActive",
			true,
		)

		let runningTaskIndexIfExists = -1

		const runningTaskIfExists = this.formattedSessionGroups.find(
			(sessionGroup, index) => {
				if (sessionGroup.isActive) {
					runningTaskIndexIfExists = index
					return true
				}
			},
		)

		// ignore sorting, and put any running task at the top.
		if (runningTaskIndexIfExists !== -1 && runningTaskIfExists) {
			this.formattedSessionGroups.splice(runningTaskIndexIfExists, 1)
			this.formattedSessionGroups.unshift(runningTaskIfExists)
		}

		this.formattedSessionGroups = this.formattedSessionGroups.slice(0, 24)
	}

	toggleDropdown = (_) => {
		this.setState({
			isDropdownOpen: !this.state.isDropdownOpen,
		})
	}

	dismissTimer = (e) => {
		e.stopPropagation()

		this.props.hideTimer(this.props.userData.id)
	}

	addMissingEntity = (type, id) => {
		if (
			this.missingEntitiesByType[type + "s"] &&
			this.missingEntitiesByType[type + "s"].indexOf(id) == -1
		) {
			this.missingEntitiesByType[type + "s"].push(id)
		} else {
			this.missingEntitiesByType[type + "s"] = [id]
		}
	}

	render() {
		const { selectedTaskId, isDropdownOpen } = this.state

		const { userData, toggleTimer, projects } = this.props

		if (!this.formattedSessionGroups.length) {
			return null
		}

		let activeSession = this.formattedSessionGroups.find((group) => {
			return group.isActive
		})

		if (!activeSession && selectedTaskId) {
			activeSession = this.formattedSessionGroups.find((group) => {
				return group.task.id === selectedTaskId
			})
		}

		let selectedSessionClassName = "selected-session"

		if (isDropdownOpen) {
			selectedSessionClassName += " open"
		}

		let timerClassName = "header-timer"

		if (activeSession?.isActive) {
			timerClassName += " active"
			selectedSessionClassName += " active"
		}

		return (
			<div
				className={timerClassName}
				ref={(ref) => (this.ref = ref)}
			>
				<div
					className={selectedSessionClassName}
					onClick={this.toggleDropdown}
				>
					<div className="task-info">
						<strong>
							{activeSession?.milestone?.name || "No milestone"}
						</strong>
						<span>{activeSession?.task?.name || "No task"}</span>
					</div>
					{activeSession ? (
						<div
							className="timer"
							onClick={(e) => {
								if (activeSession) {
									e.stopPropagation()
									toggleTimer(
										activeSession.task,
										activeSession.activeSessionId,
									)
								}
							}}
						>
							<button>
								<Icon
									name={
										activeSession.isActive
											? "pause"
											: "play"
									}
								/>
							</button>
							<HeaderTimerCounter session={activeSession} />
						</div>
					) : null}
					<Icon
						className="caret"
						name="caret-down"
					/>
				</div>
				<SmoothCollapse
					heightTransition="0.15s ease"
					className="sessions-dropdown"
					expanded={isDropdownOpen}
				>
					<ul>
						{this.formattedSessionGroups.map((group, index) => {
							if (!group.milestone || !group.task) {
								return null
							}

							return (
								<li key={index}>
									<button
										className={
											activeSession?.task?.id ==
											group.task.id
												? "active"
												: null
										}
										onClick={(_) => {
											this.changeSelectedTask(
												group.task.id,
											)
										}}
									>
										<strong className="milestone-name">
											{projects?.[group.milestone.project_id]?.name
												? <>{projects[group.milestone.project_id].name} &bull; </>
												: null}
											{group.milestone.name}
										</strong>
										<span className="task-name">
											{group.task.name}
										</span>
										<HeaderTimerCounter session={group} />
									</button>
								</li>
							)
						})}
					</ul>
				</SmoothCollapse>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		userData: getCurrentUser(state),
		sessions: state.account.entities.sessions,
		tasks: state.account.entities.tasks,
		milestones: state.account.entities.milestones,
		projects: state.account.entities.projects,
	}
}

export default connect(mapStateToProps, {
	toggleTimer,
	hideTimer,
	getMissingEntities,
})(HeaderTimer)
